
import { useEffect, useState } from 'react';
import { Modal } from 'react-bootstrap';
import { toast } from 'react-toastify';
import axiosInstance from '../../../variables/api/axiosInstance';

const AddTauxCommission = ({
  show,
  handleClose,
  editMode = false,
  selectedTauxCommission,
  tauxCommissions = [],
  onRefetch, // optionnel
}) => {
  const [categories, setCategories] = useState([]);
  const [typeIntermediaire, setTypeIntermediaire] = useState('');
  const [taux, setTaux] = useState(0);
  const [selectedCategorie, setSelectedCategorie] = useState('');
  const [loading, setLoading] = useState(false);

  const INTERMEDIAIRE_TYPES = ['COURTIER', 'AGENT_GENERAL', 'APPORTEUR_REGULIER', 'APPORTEUR_OCCASIONNEL'];

  const getCatId = (obj) => {
    if (!obj) return undefined;
    return Number(
      obj.categorieId ??
      obj.id ??
      obj.categorieID ??
      obj.idCategorie ??
      obj.categorie_id
    );
  };

  // Préremplissage en édition
  useEffect(() => {
    if (editMode && selectedTauxCommission) {
      const ti =
        typeof selectedTauxCommission.typeIntermediaire === 'string'
          ? selectedTauxCommission.typeIntermediaire
          : selectedTauxCommission.typeIntermediaire?.libelle ||
          selectedTauxCommission.typeIntermediaire?.nom ||
          '';
      setTypeIntermediaire(ti || '');
      setTaux(Number(selectedTauxCommission.taux) || 0);
      const catId = getCatId(selectedTauxCommission.categorie);
      setSelectedCategorie(catId ? String(catId) : '');
      console.group('📝 Prefill editMode');
      console.log('selectedTauxCommission:', selectedTauxCommission);
      console.groupEnd();
    } else {
      setTypeIntermediaire('');
      setTaux(0);
      setSelectedCategorie('');
    }
  }, [editMode, selectedTauxCommission]);

  // Charger catégories
  useEffect(() => {
    axiosInstance
      .get(`/api/categorie`)
      .then((res) => {
        console.groupEnd();
        setCategories(res.data || []);
      })
      .catch((err) => {
        console.groupEnd();
        toast.error('Erreur lors de la récupération des catégories');
      });
  }, []);

  // Anti-doublon côté client (pour l'ajout)
  const isDuplicateClientSide = () => {
    if (editMode) return false;
    return tauxCommissions.some((item) => {
      const leftType =
        (typeof item.typeIntermediaire === 'string'
          ? item.typeIntermediaire
          : item.typeIntermediaire?.libelle || item.typeIntermediaire?.nom || ''
        )
          .trim()
          .toLowerCase();
      const sameType = leftType === typeIntermediaire.trim().toLowerCase();
      const sameTaux = Number(item.taux) === Number(taux);
      const sameCat = getCatId(item.categorie) === Number(selectedCategorie);
      return sameType && sameTaux && sameCat;
    });
  };

  const onSubmit = async (e) => {
    e.preventDefault();

    if (!typeIntermediaire || !selectedCategorie || Number(taux) <= 0) {
      toast.error('Veuillez remplir tous les champs requis.');
      return;
    }

    if (!editMode && isDuplicateClientSide()) {
      toast.error('Ce taux existe déjà pour ce type et cette catégorie.');
      return;
    }


    // ▶️ Payloads alignés avec le backend:
    // POST: DTO { taux, typeIntermediaire, categorieId }
    const createPayload = {
      taux: Number(taux),
      typeIntermediaire,
      categorieId: Number(selectedCategorie),
    };

    // PUT: body TauxCommission avec categorie.categorieId
    const updatePayload = {
      taux: Number(taux),
      typeIntermediaire,
      categorie: { categorieId: Number(selectedCategorie) },
    };

    setLoading(true);
    const groupTitle = editMode ? '🚀 PUT /api/taux-commission/{codeId}' : '🚀 POST /api/taux-commission';
    console.group(groupTitle);
    console.log('editMode:', editMode);
    try {
      let res;
      if (editMode) {
        const codeId = selectedTauxCommission?.codeId ?? null;
        if (!codeId) {
          // console.error('codeId manquant en édition');
          toast.error('codeId manquant pour la modification.');
          return;
        }
        console.log('request body:', updatePayload);
        res = await axiosInstance.put(`/api/taux-commission/${codeId}`, updatePayload);
      } else {
        console.log('request body:', createPayload);
        res = await axiosInstance.post(`/api/taux-commission`, createPayload);
      }

      // console.log('raw response:', res);
      console.log('response.data:', res?.data);
      toast.success(editMode ? 'Modifié avec succès' : 'Ajouté avec succès');

      if (typeof onRefetch === 'function') onRefetch();
      handleClose(res.data);
    } catch (err) {
      console.error('AXIOS ERROR message:', err?.message);
      console.error('AXIOS ERROR status:', err?.response?.status);
      console.error('AXIOS ERROR data:', err?.response?.data);
      toast.error(err?.response?.data?.error || "Erreur lors de l'enregistrement.");
    } finally {
      console.groupEnd();
      setLoading(false);
    }
  };

  return (
    <Modal show={show} onHide={() => handleClose(null)} size="lg" centered>
      <Modal.Body>
        <button type="button" className="btn-close btn-primary" onClick={() => handleClose(null)}></button>
        <div className="text-center mb-4">
          <h4>{editMode ? 'Modifier' : 'Ajouter'} un taux de commission</h4>
        </div>
        <form className="row g-3" onSubmit={onSubmit}>
          <div className="col-12">
            <label className="form-label">Type d'intermédiaire</label>
            <select
              className="form-select"
              value={typeIntermediaire}
              onChange={(e) => setTypeIntermediaire(e.target.value)}
              required
            >
              <option value="">Sélectionner</option>
              {INTERMEDIAIRE_TYPES.map((type) => (
                <option key={type} value={type}>
                  {type}
                </option>
              ))}
            </select>
          </div>

          <div className="col-12">
            <label className="form-label">Taux (%)</label>
            <input
              type="number"
              className="form-control"
              value={taux}
              step="0.01"
              onChange={(e) => setTaux(Number(e.target.value) || 0)}
              placeholder="Ex: 10"
              min="0"
              required
            />
          </div>

          <div className="col-12">
            <label className="form-label">Catégorie</label>
            <select
              className="form-select"
              value={selectedCategorie}
              onChange={(e) => setSelectedCategorie(e.target.value)}
              required
            >
              <option value="">Sélectionner</option>
              {categories.map((cat) => {
                const id = getCatId(cat);
                const label = cat.nom ?? cat.libelle ?? `Catégorie #${id}`;
                return (
                  <option key={id} value={String(id)}>
                    {label}
                  </option>
                );
              })}
            </select>
          </div>

          <div className="col-12 text-center mt-4">
            <button type="submit" className="btn btn-primary me-2" disabled={loading}>
              {loading ? 'Enregistrement...' : 'Enregistrer'}
            </button>
            <button type="button" className="btn btn-secondary" onClick={() => handleClose(null)} disabled={loading}>
              Annuler
            </button>
          </div>
        </form>
      </Modal.Body>
    </Modal>
  );
};

export default AddTauxCommission;
